import React from 'react'
import { SearchBar } from 'antd-mobile'
import PropTypes from 'prop-types'

export const ProductSearchBar = (props) => {
  const { defaultValue, placeholder, onSearch } = props
  return <div className='p-2' style={{backgroundColor: 'var(--adm-color-background)' }}>
    <SearchBar defaultValue={defaultValue} placeholder={placeholder} onSearch={onSearch}/>
  </div>
}

ProductSearchBar.propTypes = {
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
}

